var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDribbbleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EC407A"
    },
    cx: 256,
    cy: 256,
    r: 245.333
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD1457"
    },
    d: "M256,512C114.615,512,0,397.385,0,256S114.615,0,256,0s256,114.615,256,256 C511.835,397.317,397.317,511.835,256,512z M256,21.333C126.397,21.333,21.333,126.397,21.333,256S126.397,490.667,256,490.667 S490.667,385.603,490.667,256C490.526,126.456,385.544,21.474,256,21.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD1457"
    },
    d: "M362.667,480c-5.642,0.011-10.317-4.374-10.667-10.005 c-12.977-163.038-83.361-316.188-198.635-432.213c-4.171-4.189-4.157-10.965,0.032-15.136c4.189-4.171,10.965-4.157,15.136,0.032 c118.893,119.737,191.462,277.763,204.8,445.973c0.365,5.879-4.105,10.941-9.984,11.307L362.667,480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD1457"
    },
    d: "M21.333,236.011c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 c143.829,0,329.323-23.467,396.181-134.827c3.125-4.994,9.707-6.509,14.701-3.384c4.867,3.046,6.45,9.397,3.582,14.371 C363.819,210.816,170.667,236.011,21.333,236.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD1457"
    },
    d: "M99.989,448.896c-5.891-0.002-10.665-4.779-10.663-10.67c0.001-1.855,0.485-3.677,1.405-5.287 c90.176-157.867,275.861-208.192,403.2-165.717c5.514,2.074,8.303,8.225,6.229,13.739c-1.963,5.22-7.617,8.047-12.971,6.485 c-119.232-39.744-293.269,7.744-378.027,156.075C107.28,446.817,103.786,448.864,99.989,448.896z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleDark);
export default __webpack_public_path__ + "static/media/DribbbleDark.e338d83966db53956f9447bdad7eae53.svg";
export { ForwardRef as ReactComponent };